define([
	"csi/_base/underscore",
	"csi/reflection",
	"csi/xml"
], function(_, reflection, xml) {

	// Object: map of node types to list of paths that should be queried to get related images
	var _paths = {
		"CanvasTemplate": [
			"Child:CanvasImages"
		],
		"CareSymbol": [
			"Child:LanguageIcons"
		],
		"ColorMaterial": [
			"Child:Images",
			"Child:DocumentsAndComments/Child:Documents/Child:LatestRevision/Child:Images",
			"Child:DocumentsAndComments/Child:ReferencedDocuments/Child:LatestRevision/Child:Images",
			"Child:ColorSpecification/Child:Images",
			"Child:DataSheets/Child:DataSheetImages",
			"Child:__Parent__/Child:Images",
			"Child:__Parent__/Child:DocumentsAndComments/Child:Documents/Child:LatestRevision/Child:Images"
		],
		"Colorway": [
			"Child:Images",
			"Child:ColorSpecification/Child:Images",
			"Child:DataSheets/Child:DataSheetImages",
			"Child:__Parent__/Child:Images",
			"Child:__Parent__/Child:DocumentsAndComments/Child:Documents/Child:LatestRevision/Child:Images",
			"Child:__Parent__/Child:DocumentsAndComments/Child:ReferencedDocuments/Child:LatestRevision/Child:Images"
		],
		"ColorSpecification": [
			"Child:Images",
			"Child:PrintSpecification/Child:Images",
			"Child:DocumentsAndComments/Child:Documents/Child:LatestRevision/Child:Images",
			"Child:DocumentsAndComments/Child:ReferencedDocuments/Child:LatestRevision/Child:Images"
		],
		"MarketingCollection": [
			"Child:Images",
			"Child:CanvasImages"
		],
		"Material": [
			"Child:Images",
			"Child:DocumentsAndComments/Child:Documents/Child:LatestRevision/Child:Images",
			"Child:DocumentsAndComments/Child:ReferencedDocuments/Child:LatestRevision/Child:Images",
			"Child:ProductColors/Child:Images",
			"Child:DataSheets/Child:DataSheetImages"
		],
		"MCMaterial": [
			"Child:Images",
			"Child:DocumentsAndComments/Child:Documents/Child:LatestRevision/Child:Images",
			"Child:DocumentsAndComments/Child:ReferencedDocuments/Child:LatestRevision/Child:Images",
			"Child:Colors/Child:Images",
			"Child:MCMaterial/Child:Images",
			"Child:MCMaterial/Child:DocumentsAndComments/Child:Documents/Child:LatestRevision/Child:Images",
			"Child:MCMaterial/Child:DocumentsAndComments/Child:ReferencedDocuments/Child:LatestRevision/Child:Images"
		],
		"MCMaterialColor": [
			"Child:Images",
			"Child:MCColorMaterial/Child:Images",
			"Child:__Parent__/Child:Images",
			"Child:__Parent__/Child:DocumentsAndComments/Child:Documents/Child:LatestRevision/Child:Images",
			"Child:__Parent__/Child:DocumentsAndComments/Child:ReferencedDocuments/Child:LatestRevision/Child:Images"
		],
		"MCProduct": [
			"Child:Images",
			"Child:DocumentsAndComments/Child:Documents/Child:LatestRevision/Child:Images",
			"Child:DocumentsAndComments/Child:ReferencedDocuments/Child:LatestRevision/Child:Images",
			"Child:Colors/Child:Images",
			"Child:ProductStyle/Child:Images",
			"Child:ProductStyle/Child:DocumentsAndComments/Child:Documents/Child:LatestRevision/Child:Images",
			"Child:ProductStyle/Child:DocumentsAndComments/Child:ReferencedDocuments/Child:LatestRevision/Child:Images"
		],
		"MCProductColor": [
			"Child:Images",
			"Child:PCColorway/Child:Images",
			"Child:__Parent__/Child:Images",
			"Child:__Parent__/Child:DocumentsAndComments/Child:Documents/Child:LatestRevision/Child:Images",
			"Child:__Parent__/Child:DocumentsAndComments/Child:ReferencedDocuments/Child:LatestRevision/Child:Images"
		],
		"PrintDesign": [
			"Child:Images",
			"Child:DocumentsAndComments/Child:Documents/Child:LatestRevision/Child:Images",
			"Child:DocumentsAndComments/Child:ReferencedDocuments/Child:LatestRevision/Child:Images",
			"Child:Colors/Child:Images",
			"Child:Colors/Child:DocumentsAndComments/Child:Documents/Child:LatestRevision/Child:Images",
			"Child:Colors/Child:DocumentsAndComments/Child:ReferencedDocuments/Child:LatestRevision/Child:Images"
		],
		"PrintDesignColor": [
			"Child:Images",
			"Child:DocumentsAndComments/Child:Documents/Child:LatestRevision/Child:Images",
			"Child:DocumentsAndComments/Child:ReferencedDocuments/Child:LatestRevision/Child:Images",
			"Child:__Parent__/Child:Images",
			"Child:__Parent__/Child:DocumentsAndComments/Child:Documents/Child:LatestRevision/Child:Images",
			"Child:__Parent__/Child:DocumentsAndComments/Child:ReferencedDocuments/Child:LatestRevision/Child:Images"
		],
		"ProductPresentationLayout": [
			"Child:__Parent__/Child:Images",
		],
		"ProductPresentationSet": [
			"Child:Images",
			"Child:MasonryGridImage",
		],
		"SizeChartReview": [
			"Child:Images",
			"Child:Style/Child:DataSheets/Child:DataSheetImages",
			"Child:Style/Child:Images",
			"Child:Style/Child:DocumentsAndComments/Child:Documents/Child:LatestRevision/Child:Images",
			"Child:Style/Child:DocumentsAndComments/Child:ReferencedDocuments/Child:LatestRevision/Child:Images"
		],
		"SizeChartRevision": [
			"Child:Images",
			"Child:__Parent__/Child:__Parent__/Child:Images",
			"Child:__Parent__/Child:__Parent__/Child:DocumentsAndComments/Child:Documents/Child:LatestRevision/Child:Images",
			"Child:__Parent__/Child:__Parent__/Child:DocumentsAndComments/Child:ReferencedDocuments/Child:LatestRevision/Child:Images",
			"Child:__Parent__/Child:__Parent__/Child:DataSheets/Child:DataSheetImages",
			"Child:__Parent__/Child:__Parent__/Child:DataSheets/Child:CurrentRevision/Child:CurrentReview/Child:DataSheetImages"
		],
		"SKU": [
			"Child:Images",
			"Child:__Parent__/Child:Images",
			"Child:DocumentsAndComments/Child:Documents/Child:LatestRevision/Child:Images",
			"Child:DocumentsAndComments/Child:ReferencedDocuments/Child:LatestRevision/Child:Images"
		],
		"Style": [
			"Child:Images",
			"Child:DocumentsAndComments/Child:Documents/Child:LatestRevision/Child:Images",
			"Child:DocumentsAndComments/Child:ReferencedDocuments/Child:LatestRevision/Child:Images",
			"Child:ProductColors/Child:Images",
			"Child:DataSheets/Child:DataSheetImages",
			"Child:DataSheets/Child:CurrentRevision/Child:CurrentReview/Child:DataSheetImages",
			"Child:Shape/Child:Images",
			"Child:ProductSourcing/Child:ProductSources/Child:Samples/Child:Images",
			"Child:ProductSourcing/Child:ProductSources/Child:SupplierItems/Child:Images",
			"Child:ProductSourcing/Child:ProductSources/Child:Samples/Child:DocumentsAndComments/Child:Documents/Child:LatestRevision/Child:Images",
			"Child:ProductSourcing/Child:ProductSources/Child:Samples/Child:DocumentsAndComments/Child:ReferencedDocuments/Child:LatestRevision/Child:Images"
		],
		"Theme": [
			"Child:Images",
			"Child:DocumentsAndComments/Child:Documents/Child:LatestRevision/Child:Images",
			"Child:DocumentsAndComments/Child:ReferencedDocuments/Child:LatestRevision/Child:Images",
			"Child:ColorColorways/Child:Actual/Child:Images",
			"Child:CanvasImages"
		]
	};

	return {
		add: function(/*String*/type, /*String*/path) {
			// summary: add path for given type
			this.get(type).push(path);
		},

		remove: function(/*String*/type, /*String*/path) {
			// summary: remove path for given type
			this.get(type).dele(path);
		},

		get: function(/*String*/type) {
			// summary: return paths for given type
			var paths = _paths[type];
			if (!paths) {
				var rc = reflection.getClass(type);
				var prefix;

				paths = [];

				// if working with data sheet, then change context to its parent if there is one
				if (rc.isDerivedFrom("DataSheet")) {
					var rcParent = rc.getParentClass();
					if (rcParent) {
						rc = rcParent;
						prefix = reflection.PATH_PARENT;
					} else {
						paths.push(xml.path("Images"));
					}
				}

				// try to order images in approximate order of importance
				if (rc.isDerivedFrom("DataSheetContainer")) {
					paths.unshift(xml.path(prefix, "DataSheets", "Images"));
				}

				if (rc.isDerivedFrom("DocAndCommentOwner")) {
					paths.unshift(xml.path(prefix, "DocumentsAndComments", "Documents", "LatestRevision", "Images"));
				}

				if (rc.isDerivedFrom("ImageContainer")) {
					paths.unshift(xml.path(prefix, "Images"));
				}

				_paths[type] = paths;
			}

			return paths;
		}
	};
});
